module.exports = __webpack_public_path__ + "img/semitrailerRearRight.ec56c345.svg";